import { U21Button } from 'app/shared/u21-ui/components';
import styled from 'styled-components';

export const SavedFilterButton = styled(U21Button).attrs({
  variant: 'ghost',
})`
  // mimics U21Tabs padding
  padding: 0 12px;
  border-radius: 8px 8px 0 0;
  height: 42px; // 40px normal button height + 2px to account for AppliedSavedFilterButton border bottom
  color: ${(props) => props.theme.palette.text.secondary};
`;
